// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609090834/js/" + chunkId + "." + {"44":"5aa00103","225":"b755c288","481":"eea396bb","486":"9553072b","770":"d3b71492"}[chunkId] + ".0.8199009119301537.chunk.js";
};